<template>
  <div>
    <slot name="change-password" />
  </div>
</template>

<script>
export default {};
</script>
